// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__24Ymx","label":"Category_label__3f67k","content":"Category_content__1D5pt","header":"Category_header__37z6_","location":"Category_location__35CYt"};